import _extends from "@babel/runtime/helpers/esm/extends";
const seriesProcessor = ({
  series,
  seriesOrder
}, dataset, isItemVisible) => {
  const completeSeries = Object.fromEntries(Object.entries(series).map(([seriesId, seriesData]) => {
    const datasetKeys = seriesData?.datasetKeys;
    const missingKeys = ['x', 'y'].filter(key => typeof datasetKeys?.[key] !== 'string');
    if (seriesData?.datasetKeys && missingKeys.length > 0) {
      throw new Error([`MUI X Charts: scatter series with id='${seriesId}' has incomplete datasetKeys.`, `Properties ${missingKeys.map(key => `"${key}"`).join(', ')} are missing.`].join('\n'));
    }
    const data = !datasetKeys ? seriesData.data ?? [] : dataset?.map(d => {
      return {
        x: d[datasetKeys.x] ?? null,
        y: d[datasetKeys.y] ?? null,
        z: datasetKeys.z && d[datasetKeys.z],
        id: datasetKeys.id && d[datasetKeys.id]
      };
    }) ?? [];
    return [seriesId, _extends({
      labelMarkType: 'circle',
      markerSize: 4
    }, seriesData, {
      preview: _extends({
        markerSize: 1
      }, seriesData?.preview),
      data,
      hidden: !isItemVisible?.({
        type: 'scatter',
        seriesId
      }),
      valueFormatter: seriesData.valueFormatter ?? (v => v && `(${v.x}, ${v.y})`)
    })];
  }));
  return {
    series: completeSeries,
    seriesOrder
  };
};
export default seriesProcessor;